import { useQuery } from '@tanstack/react-query';

export interface RoomRateInfo {
  roomType: { id: string };
  roomRate: { id: string };
}

export function useGroupedByRoomRate<T>(
  queryKey: ReadonlyArray<unknown>,
  propertyId: string,
  selectedRoomRates: Array<RoomRateInfo>,
  enabled: boolean,
  fetchRoomRateItems: (propertyId: string, roomTypeId: string, roomRateId: string) => Promise<Array<T>>,
) {
  return useQuery({
    queryKey,
    queryFn: async () => {
      const results: Record<string, Array<T>> = {};
      await Promise.all(
        selectedRoomRates.map(async (roomRateSelection) => {
          results[roomRateSelection.roomRate.id] = await fetchRoomRateItems(
            propertyId,
            roomRateSelection.roomType.id,
            roomRateSelection.roomRate.id,
          );
        }),
      );
      return results;
    },
    enabled,
  });
}
